import { NavLink } from "react-router-dom";
import { mainNavigation } from "../config/navigationMenu";
import "./TopNavigation.scss";

/**
 * Horizontale Hauptnavigation der AppShell.
 * Aufbau:
 *   Dashboard | CRM | Margenkalkulator | Cockpit | Sales
 */
export default function TopNavigation() {
  return (
    <nav className="app-shell-topnav">
      {/* Hauptnavigation */}
      <div className="app-shell-topnav__main">
        {mainNavigation.map((item) => (
          <NavLink
            key={item.id}
            to={item.path}
            end={item.path === "/app"}
            className={({ isActive }) =>
              `app-shell-topnav__item ${
                isActive ? "app-shell-topnav__item--active" : ""
              }`
            }
          >
            <item.icon className="app-shell-topnav__item-icon" />
            <span className="app-shell-topnav__item-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
